export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              精彩片花
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              热门影视片段与独家内容抢先预览，感受视觉震撼
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {/* Item 1 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20scene%20with%20starship%20and%20nebula%2C%20cinematic%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20accents%2C%20film%20poster%20quality%2C%20high%20contrast%2C%20professional%20movie%20promotional%20style&width=800&height=450&seq=media-01&orientation=landscape"
                  alt="《星际征途》终极预告 - 科幻巨制"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  2:35
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  科幻巨制
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《星际征途》终极预告</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  328万 次观看
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Noir%20detective%20film%20scene%20in%20rainy%20city%20alley%2C%20moody%20atmospheric%20lighting%2C%20warm%20amber%20street%20lamps%2C%20dark%20shadows%2C%20cinematic%20composition%2C%20professional%20movie%20promotional%20photography&width=800&height=450&seq=media-02&orientation=landscape"
                  alt="《暗夜追踪》独家花絮 - 悬疑动作"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  4:12
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  悬疑动作
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《暗夜追踪》独家花絮</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  215万 次观看
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20flowing%20silk%20curtains%2C%20warm%20golden%20lantern%20light%2C%20traditional%20elegant%20costume%2C%20soft%20dreamy%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20historical%20drama%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape"
                  alt="《大唐风华》精彩片段 - 古装历史"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  3:48
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  古装历史
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《大唐风华》精彩片段</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  456万 次观看
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20dramatic%20light%20rays%20penetrating%20dark%20water%2C%20mysterious%20submarine%20silhouette%2C%20cinematic%20blue-green%20tones%2C%20atmospheric%20suspense%2C%20professional%20movie%20visual%20style&width=800&height=450&seq=media-04&orientation=landscape"
                  alt="《深海危机》视觉解析 - 灾难大片"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  5:20
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  灾难大片
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《深海危机》视觉解析</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  189万 次观看
                </p>
              </div>
            </div>

            {/* Item 5 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Bright%20cozy%20modern%20family%20living%20room%20with%20warm%20sunlight%2C%20colorful%20decor%2C%20cheerful%20natural%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20comfortable%20home%20aesthetic%2C%20cinematic%20wide%20angle&width=800&height=450&seq=media-05&orientation=landscape"
                  alt="《欢乐一家人》爆笑集锦 - 家庭喜剧"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  6:05
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">
                  家庭喜剧
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《欢乐一家人》爆笑集锦</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  512万 次观看
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}